module.exports = __webpack_public_path__ + "img/DSLogi.a3bf5d71.svg";